export default {
  name: 'LoginRpcErrorMessage',

  props: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},
};



// WEBPACK FOOTER //
// ./src/components/Login/LoginRpcErrorMessage/component.js